// extracted by mini-css-extract-plugin
export default {"container":"Attachments_container__HWzD9"};